<template>
  <div class="office-directory-page text-center">
    <TopMenu
      :title="$t('CONTACT_US.PAGE_LABEL')"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 pr-4 pl-4 text-left">
        <h3>{{ $t('SIDEMENU.REPRESENTATIVE_REGIONS') }}</h3>
      </div>
      <div
        v-for="(office, index) in getOffices(officeDirectory)"
        :key="index"
        class="mt-3 pb-2 pr-4 pl-4 text-left border-bottom">
        <div
          class="row clickable-row mb-2 non-selectable-text"
          @click="officeClick(office.id)">
          <div class="col-10 text-left">
            <h3 class="m-0">{{ office.name }}</h3>
          </div>
          <div class="col-2 chevron justify-content-end">
            <i class="fas fa-chevron-right"/>
          </div>
        </div>
      </div>
    </div>
    <BottomMenu />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';

export default {
  name: 'OfficeDirectory',
  components: {
    TopMenu,
    BottomMenu,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('contactUs', ['officeDirectory']),
    ...mapGetters('contactUs', ['getOffices']),
  },
  watch: {},
  created() {
    this.$store.dispatch('contactUs/getOfficeDirectory');
  },
  methods: {
    officeClick(officeId) {
      this.$router.push(`/dashboard/contact-us/office-directory/${officeId}`);
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.office-directory-page {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}

.clickable-row {
  cursor: pointer;
}
.chevron {
  display: flex;
  align-items: center;
}
</style>
